export * from './useDealConfigs';
